<template>
	<div class="remark">
		<button
			type="button"
			:class="{'button--outlined': true, '--focus': isExtended}"
			@click="extendRemarkField"
		>
			<span v-if="remark === ''">Dodaj uwagi</span>
			<span v-else>Edytuj uwagi<i class="edit"></i></span>
		</button>
		<div v-if="isExtended" class="remark__extended">
			<textarea
				v-model="remark"
				class="remark__textarea"
				placeholder="Wpisz treść uwag..."
			></textarea>
			<div class="remark__save">
				<button type="button" class="button remark__save" @click="toggleRemarkField">
					Zapisz uwagi
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Remark',
	data() {
		return {
			isExtended: false,
		};
	},
	computed: {
		remark: {
			get() {
				return this.$store.state.app.remark;
			},
			set(payload) {
				this.$store.commit('setRemark', payload);
			},
		},
	},
	methods: {
		extendRemarkField() {
			this.isExtended = true;
		},
		toggleRemarkField() {
			this.isExtended = !this.isExtended;
		},
	},
};
</script>
<style lang="scss" scoped>
.remark {
	& > button {
		color: white;
		margin: 1.25rem 0;
		text-transform: uppercase;
		transition: background-color 0.3s ease-in;
	}

	&__textarea {
		background-color: transparent;
		border-radius: 5px;
		border: 2px solid #6e6e6e;
		resize: none;
		width: 100%;
		padding: 12px;
		color: #ffffff;
	}

	&__save {
		text-align: right;

		button {
			display: inline-block;
			width: 50%;
			text-align: center;
		}
	}
}
</style>
